type Props = {
  firstRole: string;
  secondRole: string;
};

export const checkRank = ({ firstRole, secondRole }: Props): boolean => {
  const roles = [
    'CLIENT',
    'SHIPPER',
    'SHIPPER_MANAGER',
    'AGENCY_DIRECTOR',
    'SHIPPER_DIRECTOR',
    'ADMIN',
  ];

  return (
    roles.findIndex((v) => v === firstRole) >
    roles.findIndex((v) => v === secondRole)
  );
};
